<template>
  <div>
    <user-guide-section
      v-model="model.userGuides"
      :avoid-required="!!model.videos.length"
      :readOnly="readOnly"
      @add="addUserGuide"
      @remove="removeUserGuide"
    />
    <video-section
      class="mt-2"
      v-model="model.videos"
      :avoid-required="!!model.userGuides.length"
      :readOnly="readOnly"
      @add="addVideo"
      @remove="removeVideo"
    />
  </div>
</template>

<script>
import UserGuideSection from './UserGuideSection.vue';
import VideoSection from './VideoSection.vue';

export default {
  name: 'TeachingMaterialInfo',
  components: {
    UserGuideSection,
    VideoSection,
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    addVideo(item) {
      this.model.videos.push(item);
    },
    removeVideo(index) {
      this.model.videos.splice(index, 1);
    },
    addUserGuide(item) {
      this.model.userGuides.push(item);
    },
    removeUserGuide(index) {
      this.model.userGuides.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.textarea__extended ::v-deep {
  .position-relative {
    i {
      display: none;
    }
  }
}

.div-time {
  margin-top: 12px !important;
}
</style>
